// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logoArea[data-v-5e70fa7f] {\n  margin: 1.5rem 0 0.5rem;\n  font-size: 2.5rem;\n  color: white;\n  font-family: \"Noto Sans\", sans-serif, \"Noto Sans TC\", sans-serif;\n  font-weight: 500;\n  line-height: 1.2;\n}\n.logoArea img[data-v-5e70fa7f] {\n  max-width: 80%;\n  width: 350px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
